import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    wrapper: _defineProperty({
      padding: "".concat(componentTheme.wrapperPadding, " 0")
    }, mp, {
      breakInside: 'avoid'
    }),
    questionSpacer: {
      height: componentTheme.spacerHeight
    },
    questionSpacerLine: {
      height: "calc(".concat(componentTheme.spacerHeight, " / 2)")
    },
    question: {
      width: '100%',
      padding: "".concat(componentTheme.questionPaddingTopBottom, " ").concat(componentTheme.questionPaddingLeftRight),
      boxSizing: 'border-box'
    },
    header: {
      display: 'flex',
      flexDirection: 'column'
    },
    headerSection: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    infoHeader: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden'
    },
    infoHeaderItem: {
      fontSize: componentTheme.pointsFontSize,
      color: componentTheme.pointsColor,
      marginRight: componentTheme.spacerWidth,
      marginLeft: componentTheme.spacerWidth,
      textOverflow: 'ellipsis'
    },
    legend: {
      border: 'none'
    },
    contentWrapper: {
      marginLeft: componentTheme.contentWrapperMargin
    },
    interactionWrapper: {
      overflowWrap: 'anywhere'
    },
    pin: _defineProperty({}, mp, {
      display: 'none'
    }),
    jumpToInfo: _defineProperty({}, mp, {
      display: 'none'
    })
  };
};
export default generateStyle;